import { ReactElement } from "react";

interface Props {
  id: string;
  isToggled: boolean;
  handleSubmit: () => void;
  text: ReactElement;
}

const BaseToggle = ({ id, isToggled, handleSubmit, text }: Props) => {
  return (
    <div className="tgl-container">
      <input
        type="checkbox"
        checked={isToggled}
        className="tgl tgl-light"
        id={id}
        onChange={handleSubmit}
      />
      <label className="tgl-btn" htmlFor={id} />
      <span>{text}</span>
    </div>
  );
};

export default BaseToggle;
